jQuery(document).ready(function ($) {
  /*------------------------------------------------------*/
  // Trigger menu on click
  /*------------------------------------------------------*/
  $('.menu-actions').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('menu-active');
  })

  $('#site-overlay').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('menu-active');
  })

  $(".sub-menu-trigger > a").click(function (e) {
    $(this).siblings('ul.sub-menu').slideToggle('100').toggleClass('active');
    $(this).toggleClass('open');
  })


});